import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import NewspaperIcon from '@mui/icons-material/Newspaper';

export const categories = [
  { name: 'New', icon: <HomeIcon />, },
  { name: 'Music', icon: <MusicNoteIcon /> },
  { name: 'Podcast', icon: <GraphicEqIcon />, },
  { name: 'Sport', icon: <FitnessCenterIcon />, },
  { name: 'Gaming', icon: <SportsEsportsIcon />, },
  { name: 'Education', icon: <SchoolIcon />, },
  { name: 'Movie', icon: <OndemandVideoIcon />, },
  { name: 'Coding', icon: <CodeIcon />, },
  { name: 'News', icon: <NewspaperIcon />, },
  { name: 'Live', icon: <LiveTvIcon />, },
  { name: 'ReactJS', icon: <CodeIcon />, },
  { name: 'NextJS', icon: <CodeIcon />, },
  { name: 'Fashion', icon: <CheckroomIcon />, },
  { name: 'Beauty', icon: <FaceRetouchingNaturalIcon />, },
  { name: 'Gym', icon: <FitnessCenterIcon />, },
  { name: 'Crypto', icon: <DeveloperModeIcon />, },
];
